const getApiBaseUrl = () => {
  // If running in development (webpack dev server)
  if (process.env.REACT_APP_ENV === 'development') {
    return process.env.REACT_APP_API_URL;
  }

  const hostname = window.location.hostname; // e.g., 'localhost' or '127.0.0.1'
  const port = window.location.port || '3000'; // Use the current port or default to 3000
  const protocol = window.location.protocol; // e.g., 'http:' or 'https:'

  // Check if the hostname is localhost or 127.0.0.1
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${port}/v1/services`;
  }


  // Actual production deployment
  return process.env.REACT_APP_API_URL;
};

const getServerUrl = () => {
  // If running in development (webpack dev server)
  if (process.env.REACT_APP_ENV === 'development') {
    return process.env.REACT_APP_SERVER_URL;
  }

  const hostname = window.location.hostname; // e.g., 'localhost' or '127.0.0.1'
  const port = window.location.port || '3000'; // Use the current port or default to 3000
  const protocol = window.location.protocol; // e.g., 'http:' or 'https:'

  // Check if the hostname is localhost or 127.0.0.1
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${port}`;
  }


  // Actual production deployment
  return process.env.REACT_APP_SERVER_URL;
};


const isUAT = () => {
  // Check for a query parameter `uat=true` in the URL
  const queryParams = new URLSearchParams(window.location.search);
  const uatParam = queryParams.get('uat');

  return uatParam === 'true';
};

const config = {
  apiBaseUrl: getApiBaseUrl(),
  serverUrl: getServerUrl(),
  isUAT: isUAT(),
};

export default config;